import { render } from "./PlatformLayout.vue?vue&type=template&id=7f80881e"
import script from "./PlatformLayout.vue?vue&type=script&lang=js"
export * from "./PlatformLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__